<template>
    <!-- 我的客户（PC） -->
    <ZhaiHeadPC class="zhai-head" />

    <div class="container errong">
        <!-- 顶部条 -->
        <div class="container-fluid mt-3">
            <div class="row shengse  mt-2">
                <div class="py-2 d-flex justify-content-between align-items-center">
                    <div class="lf go-back" @click="goBack">
                        <i class="fa fa-bullhorn"></i> 推广中心
                    </div>
                </div>
            </div>
        </div>

        <!-- 主体：（左列表，右筛选） -->
        <!-- ✅ 新增：主体页头（与其它页面同位置） -->
        <div class="page-head">
            <div class="ph-left">
                <div class="ph-title">我的客户</div>
                <div class="ph-sub">查看直推/间接客户，支持搜索与解绑操作</div>
            </div>
        </div>

        <div class="main-grid">
            <!-- ✅ 左侧：客户列表（主内容） -->
            <div class="left-col">
                <div class="panel">
                    <div class="panel-title d-flex justify-content-between align-items-center">
                        <div>
                            {{ activeTab === "direct" ? "直推客户" : "间接客户" }}
                            <span class="muted" style="font-size: 12px; font-weight: 600; margin-left: 8px">
                共 {{ currentState.total }} 人
              </span>
                        </div>

                        <div class="muted" style="font-size: 12px">
                            更新时间：{{ lastUpdate }}
                        </div>
                    </div>

                    <!-- Loading / Empty -->
                    <div v-if="currentState.loading" class="empty">加载中...</div>
                    <div v-else-if="pagedList.length === 0" class="empty">
                        暂无{{ activeTab === "direct" ? "直推" : "间接" }}客户
                    </div>

                    <!-- ✅ 表格列表（表头/数据强制对齐） -->
                    <div v-else class="table-wrap">
                        <table
                                class="my-table"
                                style="width: 100%; table-layout: fixed; border-collapse: collapse;"
                        >
                            <!-- ✅ 关键：col 直接写 inline 宽度（绝对生效） -->
                            <colgroup>
                                <col style="width: 52px" />
                                <col />
                                <col style="width: 180px" />
                                <col style="width: 160px" />
                            </colgroup>

                            <thead>
                            <tr>
                                <!-- ✅ 关键：th 也写死 width + 对齐 -->
                                <th style="width: 52px; text-align: left; padding: 8px 11px;">头像</th>
                                <th style="text-align: left; padding: 8px 20px;">客户</th>
                                <th style="width: 180px; text-align: left; padding: 8px 48px;">绑定时间</th>
                                <th style="width: 160px; text-align: right; padding: 8px 30px;">操作</th>
                            </tr>
                            </thead>

                            <tbody>
                            <tr v-for="item in pagedList" :key="item.id">
                                <!-- ✅ 关键：td 也写死 width + 对齐，保证列对齐 -->
                                <td style="width: 52px; text-align: left; padding: 8px 10px; vertical-align: middle;">
                                    <img class="avatar" :src="item.avatar" alt="avatar" />
                                </td>

                                <td style="text-align: left; padding: 8px 10px; vertical-align: middle; overflow: hidden;">
                                    <div class="name">
                                        <span class="name-text">{{ item.name }}</span>

                                    </div>
                                </td>

                                <td
                                        class="muted"
                                        style="width: 180px; text-align: left; padding: 8px 10px; vertical-align: middle; white-space: nowrap;"
                                >
                                    {{ item.time }}
                                </td>

                                <td
                                        style="width: 160px; text-align: right; padding: 8px 10px; vertical-align: middle; white-space: nowrap;"
                                >
                                    <button class="btn-ghost" @click="openUnbindModal(item)">
                                        <i class="fa fa-chain-broken"></i> 解绑
                                    </button>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>

                    <!-- 分页 -->
                    <div class="pager-bar" v-if="currentState.total > 0">
                        <div class="pager">
                            <button class="pg-btn pg-nav" :disabled="page <= 1" @click="toPage(page - 1)">
                                «
                            </button>

                            <button
                                    v-for="p in pageItems"
                                    :key="String(p)"
                                    class="pg-btn"
                                    :class="{ active: p === page }"
                                    :disabled="p === '...'"
                                    @click="p === '...' ? null : toPage(p)"
                            >
                                {{ p }}
                            </button>

                            <button class="pg-btn pg-nav" :disabled="page >= totalPages" @click="toPage(page + 1)">
                                »
                            </button>
                        </div>

                        <div class="muted" style="font-size: 12px">
                            第 {{ page }} / {{ totalPages }} 页，每页 {{ pageSize }} 条
                        </div>
                    </div>
                </div>
            </div>

            <!-- ✅ 右侧：类型切换 / 搜索 / 提示 -->
            <div class="right-col">
                <div class="panel">
                    <div class="panel-title">客户类型</div>

                    <div class="segmented">
                        <button
                                class="seg-btn"
                                :class="{ active: activeTab === 'direct' }"
                                @click="switchTab('direct')"
                        >
                            直推客户
                        </button>

                        <button
                                class="seg-btn"
                                :class="{ active: activeTab === 'indirect' }"
                                @click="switchTab('indirect')"
                        >
                            间接客户
                        </button>
                    </div>

                    <div class="divider"></div>

                    <div class="panel-title" style="margin-bottom: 10px">搜索</div>
                    <div class="field-row">
                        <input
                                class="input"
                                v-model.trim="keyword"
                                placeholder="输入客户昵称 进行搜索"
                                @keyup.enter="applySearch"
                        />
                        <button class="btn-primary" @click="applySearch">
                            <i class="fa fa-search"></i> 搜索
                        </button>
                    </div>
                    <div class="field-help muted">支持模糊匹配。回车也可搜索。</div>

                    <div class="divider"></div>

                    <div class="panel-title">提示</div>
                    <div class="tips">
                        <div class="tip-item">
                            <i class="fa fa-info-circle"></i>
                            <span>解绑客户后，将不再获得其分销佣金。</span>
                        </div>
                        <div class="tip-item">
                            <i class="fa fa-shield"></i>
                            <span>建议保留高活跃客户，解绑操作请谨慎。</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="gongxi2"></div>

    <!-- ✅ 解绑确认弹窗 -->
    <div v-if="unbindModal.visible" class="modal-mask" @click.self="closeUnbindModal">
        <div class="modal-card" role="dialog" aria-modal="true">
            <div class="modal-title">解绑客户？</div>
            <div class="modal-desc">
                解绑后将无法继续获取其分销佣金<br />
                <span class="muted">
          客户：{{ unbindModal.customer?.name }}（ID: {{ unbindModal.customer?.id }}）
        </span>
            </div>

            <div class="modal-actions">
                <button class="modal-btn cancel" @click="closeUnbindModal" :disabled="unbindModal.loading">
                    取消
                </button>
                <button class="modal-btn ok" @click="confirmUnbind" :disabled="unbindModal.loading">
                    {{ unbindModal.loading ? "处理中..." : "确定解绑" }}
                </button>
            </div>
        </div>
    </div>

    <ZhaiFootPC />
</template>

<script>
    import ZhaiHeadPC from "../componentspc/ZhaiHeadPC";
    import ZhaiFootPC from "../componentspc/ZhaiFootPC";
    import http from "../utils/http.js";

    export default {
        name: "PMyCustomers",
        components: { ZhaiHeadPC, ZhaiFootPC },

        data() {
            return {
                lastUpdate: "—",
                activeTab: "direct",
                keyword: "",

                // 前端分页（你现在 UI 是前端分页）
                pageSize: 10,
                pageMap: {
                    direct: 1,
                    indirect: 1,
                },

                store: {
                    direct: { list: [], total: 0, loading: false, loaded: false },
                    indirect: { list: [], total: 0, loading: false, loaded: false },
                },

                unbindModal: {
                    visible: false,
                    loading: false,
                    customer: null,
                },
            };
        },

        computed: {
            currentState() {
                return this.store[this.activeTab];
            },
            page() {
                return this.pageMap[this.activeTab];
            },
            totalPages() {
                return Math.max(1, Math.ceil((this.currentState.total || 0) / this.pageSize));
            },

            filteredList() {
                const list = this.currentState.list || [];
                const kw = (this.keyword || "").trim();
                if (!kw) return list;

                const k = kw.toLowerCase();
                return list.filter((x) => {
                    const name = String(x.name || "").toLowerCase();
                    const id = String(x.id || "").toLowerCase();
                    return name.includes(k) || id.includes(k);
                });
            },

            pagedList() {
                const p = this.page;
                const start = (p - 1) * this.pageSize;
                return this.filteredList.slice(start, start + this.pageSize);
            },

            pageItems() {
                const total = this.totalPages;
                const cur = this.page;
                if (total <= 1) return [];
                if (total <= 7) return Array.from({ length: total }, (_, i) => i + 1);

                // 简化：只显示当前页、首尾
                if (cur === 1) return [1, 2, 3, "...", total];
                if (cur === 2) return [1, 2, 3, "...", total];
                if (cur === total) return [1, "...", total - 2, total - 1, total];
                if (cur === total - 1) return [1, "...", total - 2, total - 1, total];

                return [1, "...", cur - 1, cur, cur + 1, "...", total];
            },
        },

        mounted() {
            this.lastUpdate = new Date().toLocaleString();
            this.loadTab("direct", { force: true });
        },

        methods: {
            // -------------------------
            // ✅ 取 userId（仿照你同项目风格：优先 localStorage 的 user / getUser）
            // -------------------------
            getUserId() {
                // 1) 如果你项目有 vuex getUser，也可以加：this.$store.getters.getUser?.id
                // 2) 这里用最通用的 localStorage 兜底（你截图里请求带 userId=9 就是这种做法）
                try {
                    const u = JSON.parse(localStorage.getItem("user") || "{}");
                    const id = u && (u.id || u.userId);
                    return id ? Number(id) : null;
                } catch (e) {
                    return null;
                }
            },

            // -------------------------
            // UI 交互
            // -------------------------
            switchTab(type) {
                if (this.activeTab === type) return;
                this.activeTab = type;
                this.keyword = "";
                this.pageMap[type] = 1;
                this.loadTab(type);
            },

            applySearch() {
                // 你现在是“前端过滤”，不需要请求后端
                this.pageMap[this.activeTab] = 1;

                // 如果你想“搜索也走后端”，就打开下面这行：
                // this.loadTab(this.activeTab, { force: true });
            },

            goBack() {
                if (window.history.length > 1) window.history.back();
                else window.location.href = "/Promotion";
            },

            toPage(p) {
                const page = Math.min(Math.max(1, p), this.totalPages);
                this.pageMap[this.activeTab] = page;
            },

            openUnbindModal(customer) {
                this.unbindModal.customer = customer;
                this.unbindModal.visible = true;
            },

            // ✅ 修复：loading 时也能强制关
            closeUnbindModal(force = false) {
                if (this.unbindModal.loading && !force) return;
                this.unbindModal.visible = false;
                this.unbindModal.customer = null;
            },

            // -------------------------
            // ✅ 后端接口：customers 列表
            // 你 Network 里已经是：customers?userId=9&type=direct&pageNum=1&pageSize=10&keyword=
            // 这里只是把结果转成前端需要的字段：id/name/time/avatar
            // -------------------------
            async apiFetchCustomers(type) {
                const userId = this.getUserId();
                if (!userId) {
                    // 和你现有项目一致：直接 alert
                    alert("userId不可为空（未获取到用户信息）");
                    return { list: [], total: 0 };
                }

                // 如果你后端已经支持从 token 解析 userId，可以把 userId 参数去掉
                const res = await http.get("/platform/promo/customers", {
                    userId,
                    type,
                    pageNum: 1,
                    pageSize: 9999, // 前端分页，先取全量
                    keyword: "",    // 你要后端搜索就传 this.keyword
                });

                const json = res && res.data;
                if (!json || Number(json.status) !== 1) {
                    throw new Error((json && json.msg) || "加载客户失败");
                }

                const d = json.data || {};

                // 兼容两种返回：
                // A) { list: [...], total: 123 }
                // B) PageInfo: { list: [...], total: 123 } 或 { pageInfo: { list, total } }
                const rawList =
                    d.list ||
                    (d.pageInfo && d.pageInfo.list) ||
                    [];

                const total =
                    Number(d.total) ||
                    Number(d.pageInfo && d.pageInfo.total) ||
                    Number(d.count) ||
                    rawList.length ||
                    0;

                // ✅ 映射成前端表格需要的字段
                const list = (rawList || []).map((x) => {
                    const id = x.id ?? x.userId ?? x.customerId;
                    const name = x.username ?? x.nickname ?? x.name ?? ("用户" + id);

                    // 绑定时间：直推看 create_time / update_time / bind_time；间推同理
                    const time =
                        x.time ||                         // ✅ 把后端的 time 接进来
                        x.bindTime || x.bind_time ||
                        x.createTime || x.create_time ||
                        x.updateTime || x.update_time ||
                        "—";


                    // 头像字段（你 DB 里如果没有，就给默认图）
                    const avatar =
                        x.avatar ||
                        x.headImg ||
                        x.head_img ||
                        "https://dummyimage.com/80x80/cccccc/ffffff.png&text=🙂";

                    return { id, name, time, avatar };
                });

                return { list, total };
            },

            // -------------------------
            // ✅ 后端接口：解绑
            // POST /platform/promo/unbind?userId=9
            // Body: { customerId: xxx, type: "direct"/"indirect" }
            // -------------------------
            async apiUnbindCustomer(payload) {
                const userId = this.getUserId();
                if (!userId) {
                    alert("userId不可为空（未获取到用户信息）");
                    return null;
                }

                const res = await http.post(`/platform/promo/unbind?userId=${userId}`, payload);
                return res && res.data;
            },

            // -------------------------
            // ✅ 解绑动作（修复：字段对齐 + 本地移除 + 强制刷新 + 强制关弹窗）
            // -------------------------
            async confirmUnbind() {
                if (!this.unbindModal.customer || this.unbindModal.loading) return;

                this.unbindModal.loading = true;
                try {
                    const customer = this.unbindModal.customer;

                    // ✅ 关键：后端要 customerId，不是 id
                    const payload = {
                        customerId: customer.id,
                        type: this.activeTab, // direct / indirect
                    };

                    const res = await this.apiUnbindCustomer(payload);

                    // 你的 R.success 是 status=1
                    if (res && Number(res.status) === 1) {
                        // 1) 本地先移除一条
                        const st = this.store[this.activeTab];
                        st.list = (st.list || []).filter((x) => x.id !== customer.id);
                        st.total = Math.max(0, (st.total || 0) - 1);

                        // 2) 调整页码（避免删完一页后页码越界）
                        const tp = Math.max(1, Math.ceil((st.total || 0) / this.pageSize));
                        if (this.pageMap[this.activeTab] > tp) this.pageMap[this.activeTab] = tp;

                        // 3) 强制关闭弹窗（不受 loading 限制）
                        this.closeUnbindModal(true);

                        // 4) 强制刷新一次（保证与后端一致）
                        await this.loadTab(this.activeTab, { force: true });
                    } else {
                        alert((res && res.msg) || "解绑失败");
                    }
                } catch (e) {
                    console.error(e);
                    alert("解绑失败（网络异常）");
                } finally {
                    this.unbindModal.loading = false;
                }
            },

            // -------------------------
            // 加载列表（按 tab 缓存）
            // -------------------------
            async loadTab(type, { force = false } = {}) {
                const st = this.store[type];
                if (st.loading) return;
                if (st.loaded && !force) return;

                st.loading = true;
                try {
                    const res = await this.apiFetchCustomers(type);
                    st.list = Array.isArray(res.list) ? res.list : [];
                    st.total = Number(res.total || st.list.length || 0);
                    st.loaded = true;
                    this.lastUpdate = new Date().toLocaleString();
                } catch (e) {
                    console.error(e);
                    alert(e && e.message ? e.message : "加载失败");
                } finally {
                    st.loading = false;
                }
            },
        },
    };
</script>



<style scoped>
    /* =========================================
       ✅ 统一圆角 2px（只作用在 .container.errong 内）
       ========================================= */
    .container.errong {
        --ui-radius: 2px;
    }

    .container.errong .container-fluid.mt-3,
    .container.errong .panel,
    .container.errong .segmented,
    .container.errong .seg-btn,
    .container.errong .input,
    .container.errong .btn-primary,
    .container.errong .btn-ghost,
    .container.errong .table-wrap,
    .container.errong .pager,
    .container.errong .pg-btn,
    .container.errong .modal-card,
    .container.errong .badge {
        border-radius: var(--ui-radius) !important;
    }

    .container.errong .panel,
    .container.errong .table-wrap {
        overflow: hidden;
    }
    /* ✅ 新增：页头（与其它页面保持一致风格） */
    .page-head {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 12px;
        padding: 14px 14px;
        background: #fff;
        border: 1px solid #f0f0f0;
        border-radius: var(--ui-radius);
        margin-top: 10px;
        margin-bottom: 12px;
    }

    .ph-left { min-width: 0; }
    .ph-title { font-size: 16px; font-weight: 700; color: #111; }
    .ph-sub { margin-top: 6px; font-size: 13px; color: #888; }

    .ph-right { display: flex; gap: 10px; flex-wrap: wrap; }

    .btn-soft {
        height: 36px;
        padding: 0 12px;
        border-radius: var(--ui-radius);
        border: 1px solid #eaeaea;
        background: #fafafa;
        font-size: 13px;
        cursor: pointer;
        color: #333;
        display: inline-flex;
        align-items: center;
        gap: 8px;
    }
    .btn-soft:active { opacity: 0.8; }
    .btn-soft .fa { margin-right: 0; color: #00c26f; }


    /* 基础布局 */
    .gongxi2 {
        height: 20px;
    }
    .go-back {
        cursor: pointer;
        user-select: none;
    }

    .go-back:hover {
        opacity: 0.85;
    }

    .errong {
        padding-left: 30px;
        padding-right: 30px;
        margin-top: 80px;
    }

    @media (max-width: 767.98px) {
        .errong {
            margin-top: 0;
            padding-left: 12px;
            padding-right: 12px;
        }
    }

    .zhai-head {
        position: fixed;
        top: 0;
        width: 100%;
        z-index: 1000;
    }

    .lf {
        font-weight: 700;
        color: #111;
        font-size: 14px;
    }

    .muted {
        color: #999;
    }

    .divider {
        height: 1px;
        background: #f0f0f0;
        margin: 14px 0;
    }

    /* ✅ 主体左右分栏 */
    .main-grid {
        margin-top: 10px;
        display: grid;
        grid-template-columns: 1.1fr 0.9fr;
        gap: 12px;
        align-items: start;
    }

    @media (max-width: 1100px) {
        .main-grid {
            grid-template-columns: 1fr;
        }
    }

    /* 面板 */
    .panel {
        background: #fff;
        border: 1px solid #f0f0f0;
        padding: 16px;
        margin-bottom: 10px;
    }

    .panel-title {
        font-size: 14px;
        font-weight: 600;
        color: #111;
        margin-bottom: 12px;
    }

    /* segmented */
    .segmented {
        border: 1px solid #f0f0f0;
        background: #fafafa;
        padding: 6px;
        display: flex;
        gap: 8px;
    }

    .seg-btn {
        flex: 1;
        border: 1px solid #eaeaea;
        background: #fff;
        height: 38px;
        cursor: pointer;
        font-weight: 500;
        font-size: 13px;
        color: #333;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        transition: all 0.15s ease;
    }

    .seg-btn:hover {
        border-color: rgba(0, 194, 111, 0.35);
    }

    .seg-btn.active {
        background: rgba(0, 194, 111, 0.1);
        border-color: rgba(0, 194, 111, 0.35);
        color: #00c26f;
    }

    .badge {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        min-width: 24px;
        height: 18px;
        padding: 0 6px;
        font-size: 11px;
        border: 1px solid #eaeaea;
        background: #fff;
        color: #666;
        font-weight: 400;
    }

    /* 搜索 */
    .field-row {
        display: flex;
        gap: 10px;
        align-items: center;
    }

    .input {
        flex: 1;
        height: 40px;
        border: 1px solid #eaeaea;
        padding: 0 10px;
        outline: none;
        font-size: 13px;
        font-weight: 400;
        background: #fafafa;
    }

    .field-help {
        margin-top: 8px;
        font-size: 12px;
        font-weight: 400;
    }

    /* tips */
    .tips {
        display: grid;
        gap: 10px;
    }
    .tip-item {
        display: flex;
        gap: 10px;
        align-items: flex-start;
        color: #555;
        font-size: 12px;
        font-weight: 400;
    }
    .tip-item .fa {
        color: #00c26f;
        margin-top: 2px;
    }

    /* 表格容器 */
    .table-wrap {
        border: 1px solid #f0f0f0;
        overflow-x: auto;
    }

    /* ✅ 强制基础表头表体样式（防止被全局 table 样式覆盖） */
    .my-table thead th {
        background: #fafafa !important;
        border-bottom: 1px solid #f0f0f0 !important;
        font-size: 12px !important;
        color: #666 !important;
        font-weight: 500 !important;
    }

    .my-table tbody td {
        border-bottom: 1px solid #f5f5f5 !important;
        font-size: 14px !important;
        color: #333 !important;
    }

    /* hover */
    .my-table tbody tr:hover {
        background: rgba(0, 0, 0, 0.015);
    }

    /* 头像 */
    .avatar {
        width: 28px;
        height: 28px;
        border-radius: 50% !important;
        object-fit: cover;
        background: #e5e7eb;
    }

    /* 客户名 */
    .name {
        font-weight: 500;
        font-size: 14px;
        color: #222;
        display: flex;
        gap: 6px;
        align-items: baseline;
        min-width: 0;
    }

    .name-text {
        min-width: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .sub {
        font-weight: 400;
        font-size: 12px;
        color: #999;
        white-space: nowrap;
    }

    /* 按钮 */
    .btn-primary {
        height: 40px;
        padding: 0 12px;
        border: none;
        color: #fff;
        font-weight: 600;
        font-size: 13px;
        cursor: pointer;
        background: linear-gradient(90deg, #00c26f, #19d184);
        display: inline-flex;
        align-items: center;
        gap: 8px;
        white-space: nowrap;
    }

    .btn-ghost {
        height: 32px;
        padding: 0 10px;
        border: 1px solid #eaeaea;
        background: #fff;
        cursor: pointer;
        font-weight: 500;
        font-size: 13px;
        color: #333;
        display: inline-flex;
        align-items: center;
        gap: 6px;
    }

    .btn-ghost:hover {
        border-color: rgba(0, 194, 111, 0.35);
    }

    /* 空态 */
    .empty {
        padding: 46px 12px;
        text-align: center;
        color: #9aa1ad;
        font-size: 13px;
        font-weight: 400;
    }

    /* 分页 */
    .pager-bar {
        margin-top: 12px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 12px;
    }

    .pager {
        display: inline-flex;
        align-items: center;
        border: 1px solid #e5e7eb;
        overflow: hidden;
        background: #fff;
    }

    .pg-btn {
        min-width: 36px;
        height: 32px;
        padding: 0 8px;
        border: 0;
        background: transparent;
        color: #6b7280;
        font-size: 12px;
        font-weight: 400;
        cursor: pointer;
        border-right: 1px solid #eef0f5;
    }

    .pg-btn:last-child {
        border-right: 0;
    }

    .pg-btn.active {
        background: #111827;
        color: #fff;
        font-weight: 500;
    }

    .pg-btn:disabled {
        opacity: 0.45;
        cursor: not-allowed;
    }

    .pg-nav {
        background: #eef2f7;
    }

    /* 弹窗 */
    .modal-mask {
        position: fixed;
        inset: 0;
        z-index: 9999;
        background: rgba(0, 0, 0, 0.55);
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 18px;
    }

    .modal-card {
        width: 100%;
        max-width: 520px;
        background: #fff;
        overflow: hidden;
        box-shadow: 0 18px 60px rgba(0, 0, 0, 0.25);
    }

    .modal-title {
        text-align: center;
        font-size: 16px;
        font-weight: 600;
        padding: 18px 18px 10px;
        color: #111827;
    }

    .modal-desc {
        text-align: center;
        font-size: 13px;
        font-weight: 400;
        color: #6b7280;
        padding: 0 18px 16px;
    }

    .modal-actions {
        display: flex;
        border-top: 1px solid #eef0f5;
    }

    .modal-btn {
        flex: 1;
        height: 50px;
        border: 0;
        background: #fff;
        font-size: 14px;
        cursor: pointer;
        font-weight: 600;
    }

    .modal-btn:disabled {
        opacity: 0.6;
        cursor: not-allowed;
    }

    .modal-btn.cancel {
        color: #6b7280;
        border-right: 1px solid #eef0f5;
    }

    .modal-btn.ok {
        color: #22c55e;
    }

    .modal-btn:active:not(:disabled) {
        background: #f6f7fb;
    }
</style>
